"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../Component"));

var _main = _interopRequireDefault(require("../templates/main"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SnackBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SnackBar, _Component);

  function SnackBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SnackBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SnackBar).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _main["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "recalculateOffsets", function () {
      var snacks = _this.state.snacks,
          spacing = Number(_this.props.spacing);
      var accumulatedOffset = Number(_this.props.screenY);
      return _this.setState({
        snacks: snacks.map(function (snack) {
          var result = _objectSpread({}, snack, {
            offset: accumulatedOffset
          });

          accumulatedOffset += snack.height + spacing;
          return result;
        })
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSnackHeight",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(id, height) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setState({
                  snacks: _this.state.snacks.map(function (snack) {
                    return snack.id === id ? _objectSpread({}, snack, {
                      height: height
                    }) : snack;
                  })
                });

              case 2:
                return _context.abrupt("return", _this.recalculateOffsets());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "prepareSnack", function (snack) {
      var id = (0, _uniqueId2["default"])();
      return _objectSpread({
        id: id
      }, snack, {
        open: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addSnack",
    /*#__PURE__*/
    function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(snack) {
        var snacks, maxSnacks;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                snacks = _this.state.snacks, maxSnacks = _this.props.maxSnacks;

                if (!(!snack.message && typeof snack.render !== 'function')) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                snack = _this.prepareSnack(snack);

                if (!(snacks.length >= maxSnacks)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", _this.enqueueSnack(snack));

              case 8:
                return _context2.abrupt("return", _this._addSnack(snack));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_addSnack",
    /*#__PURE__*/
    function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(snack) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _this.setState({
                  snacks: [].concat((0, _toConsumableArray2["default"])(_this.state.snacks), [snack])
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "enqueueSnack",
    /*#__PURE__*/
    function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(snack) {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this.queue.push(snack);

                if (!_this.props.hideOldestOnAdd) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return _this.hideOldest();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideOldest", function () {
      // 0 === oldest
      return _this.hideSnack(_this.state.snacks[0].id);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hideSnack", function (snackId) {
      return _this.setState({
        snacks: _this.state.snacks.map(function (snack) {
          return snack.id === snackId ? _objectSpread({}, snack, {
            open: false
          }) : snack;
        })
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onHideEnd",
    /*#__PURE__*/
    function () {
      var _ref5 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee5(snackId) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.deleteSnack(snackId);

              case 2:
                return _context5.abrupt("return", _this.moveOtherSnacks(snackId));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteSnack", function (snackId) {
      return _this.setState({
        snacks: _this.state.snacks.filter(function (snack) {
          return snack.id !== snackId;
        })
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "moveOtherSnacks", function () {
      return _this.recalculateOffsets();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMoveEnd", function () {
      return _this.showNextSnack();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showNextSnack",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee6() {
      var snacks, maxSnacks, snack;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              snacks = _this.state.snacks, maxSnacks = _this.props.maxSnacks;

              if (!(_this.queue.length && snacks.length < maxSnacks)) {
                _context6.next = 4;
                break;
              }

              snack = _this.queue.shift();
              return _context6.abrupt("return", _this._addSnack(snack));

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    _this.state = {
      snacks: []
    };
    _this.queue = [];
    _this.timeout = null;
    return _this;
  }

  return SnackBar;
}(_Component2["default"]);

(0, _defineProperty2["default"])(SnackBar, "displayName", 'SnackBarProvider');
(0, _defineProperty2["default"])(SnackBar, "propTypes", {
  top: _propTypes["default"].bool,
  bottom: _propTypes["default"].bool,
  left: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  timeout: _propTypes["default"].number,
  hideOldestOnAdd: _propTypes["default"].bool,
  maxSnacks: _propTypes["default"].number,
  screenY: _propTypes["default"].number,
  screenX: _propTypes["default"].number,
  spacing: _propTypes["default"].number,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default palette.transitionDuration
     */
    duration: _propTypes["default"].string,

    /**
     * @default palette.transitionFunction
     */
    timingFunction: _propTypes["default"].string,

    /**
     * @default ${palette.gutter}px
     */
    paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ${palette.gutter * 5}px
     */
    paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ${palette.gutter}px
     */
    paddingBottom: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ${palette.gutter * 2}px
     */
    paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default ${palette.gutter / 2}px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default palette.minWidthMobile
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 45
     */
    maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tsSmall
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlSmall
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 0 8px 12px 0 ${palette.elShadow}, 0 6px 12px 0 ${palette.elShadow}
     */
    boxShadow: _propTypes["default"].string,

    /**
     * @default null
     */
    animationShow: _propTypes["default"].any,

    /**
     * @default null
     */
    animationHide: _propTypes["default"].any,

    /**
     * @default ${palette.gutter}px
     */
    closeIconTop: _propTypes["default"].string,

    /**
     * @default ${palette.gutter}px
     */
    closeIconRight: _propTypes["default"].string,

    /**
     * @default iconClose
     */
    closeIcon: _propTypes["default"].string,

    /**
     * @default ${palette.gutter * 3}px
     */
    iconWidth: _propTypes["default"].string,

    /**
     * @default ${palette.gutter * 3}px
     */
    iconHeight: _propTypes["default"].string,

    /**
     * @default palette.elBlack
     */
    background: _propTypes["default"].string,

    /**
     * @default url(${iconInfo})
     */
    icon: _propTypes["default"].string,

    /**
     * @default palette.tInversion
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    backgroundPrimary: _propTypes["default"].string,

    /**
     * @default url(${iconPrimary})
     */
    iconPrimary: _propTypes["default"].string,

    /**
     * @default palette.elWarning
     */
    backgroundWarning: _propTypes["default"].string,

    /**
     * @default url(${iconWarning})
     */
    iconWarning: _propTypes["default"].string,

    /**
     * @default palette.elError
     */
    backgroundError: _propTypes["default"].string,

    /**
     * @default url(${iconError})
     */
    iconError: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(SnackBar, "defaultProps", {
  timeout: 3000,
  hideOldestOnAdd: true,
  maxSnacks: 3,
  screenY: 16,
  screenX: 16,
  spacing: 16,
  top: false,
  bottom: true,
  left: true,
  right: false
});
var _default = SnackBar;
exports["default"] = _default;